import { LoggerService } from '@app/shared/services/logger.service';
import { Injectable, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DevicesService } from '@app/certificates/devices/devices.service';
import { InfoService } from '@app/core/info/info.service';
import {
    DevicesActionTypes, ActionDevicesError, ActionDevicesDelete, selectorDevice,
    ActionDevicesDeleteSuccess, ActionRemoveDeviceFromCertificatе, ActionUpdateCertificatеsForDevice
} from '@app/certificates/devices/devices.reducer';
import { switchMap, tap, first, map } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { ActionCertificatesInitialize, selectorCertificate } from '@app/certificates/manage/manage.reducer';

@Injectable()
export class ManageDevicesEffects {

    private actions$ = inject(Actions<Action>)
    private store = inject(Store<any>)
    private service = inject(DevicesService)
    private info = inject(InfoService)
    private logger = inject(LoggerService)


    deleteSuccess$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(DevicesActionTypes.DELETE_SUCCESS),
                tap((action: ActionDevicesDeleteSuccess) => {
                    this.store.select(selectorCertificate)
                        .pipe(first())
                        .subscribe(certificateResult => {
                            let certificates = JSON.parse(JSON.stringify(certificateResult));
                            certificates = certificates.map(cert => {
                                // if cert req id is send then we are removing the device only for that certificate
                                if (action.payload.certReqId != null && action.payload.certReqId === cert.certReqId) {
                                    cert.deviceIds = cert.deviceIds.filter(id => id !== action.payload.deletedDeviceId);
                                }
                                return cert;
                            });
                            this.store.dispatch(new ActionCertificatesInitialize({ certificates }));
                        });
                })
            )
    }, { dispatch: false });


    operationFailed$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(DevicesActionTypes.ERROR));
    }, { dispatch: false })


    deleteDevice$ = createEffect(() => {
        const subject = new BehaviorSubject<{ deviceId: string }>(null);
        return this.actions$
            .pipe(ofType(DevicesActionTypes.DELETE),
                switchMap((action: ActionDevicesDelete) => {
                    subject.next({ deviceId: action.payload.deviceId });
                    return this.service.deleteDevice(action.payload.deviceId);
                }),
                map((response: ISpringResponseBody) => {
                    if (response && response.status === 200) {
                        this.info.success(response.message);
                        this.store.select(selectorDevice)
                            .pipe(first())
                            .subscribe(devicesResult => {
                                const devices = devicesResult.filter(device => device.appId !== subject.value.deviceId ? device : null);
                                this.store.dispatch(new ActionDevicesDeleteSuccess({
                                    devices,
                                    deletedDeviceId: subject.value.deviceId,
                                    certReqId: null
                                }));
                            });
                    } else {
                        this.logger.log('devices.effects.ts: deleteDevice: error occured.' + response);
                        return new ActionDevicesError({ response });
                    }
                })
            )
    }, { dispatch: false });




    removeDeviceFromCertificate$ = createEffect(() => {
        const subject = new BehaviorSubject<{ deviceId: string, certReqId: string }>(null);
        return this.actions$
            .pipe(ofType(DevicesActionTypes.REMOVE_DEVICE_FROM_CERTIFICATE),
                switchMap((action: ActionRemoveDeviceFromCertificatе) => {
                    subject.next({ deviceId: action.payload.deviceId, certReqId: action.payload.certReqId });
                    return this.service.removeDeviceFromCertificate(action.payload.deviceId, action.payload.certReqId);
                }),
                map((response: ISpringResponseBody) => {
                    if (response && response.status === 200) {
                        this.info.success(response.message);
                        this.store.select(selectorDevice)
                            .pipe(first())
                            .subscribe(devicesResult => {
                                this.store.dispatch(new ActionUpdateCertificatеsForDevice({
                                    deviceId: subject.value.deviceId,
                                    certReqId: subject.value.certReqId
                                }));
                            });
                    } else {
                        return new ActionDevicesError({ response });
                    }
                })
            )
    }, { dispatch: false });

}
